import { LOCATION_ID_LSK } from 'app.constants'

// an interface declaration to handle the window.locationId type:
declare global {
    interface Window {
        locationId: string | undefined
    }
}

export const getStorageLocationId = () => {
    let id = null
    try{
        id = localStorage.getItem(LOCATION_ID_LSK) ?? null
    }catch(e){
        id = window.locationId ?? null
    }
    return id
}

export const getLocationId = () => {
    const id = getStorageLocationId()
    return id === 'all' ? null : id
}

export const updateLocationId = (id: string | null) => {
    try{
        if(id){
            localStorage.setItem(LOCATION_ID_LSK, id)
        }else{
            localStorage.removeItem(LOCATION_ID_LSK)
        }
    }catch(e){
        window.locationId = id ?? undefined
    }
}
